var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    directives: [{
      name: "el-resize",
      rawName: "v-el-resize",
      value: _vm.onResize,
      expression: "onResize"
    }],
    staticClass: "relative d-flex justify-center align-center"
  }, [_vm.selected ? _c('dialog-scroll-lock', {
    attrs: {
      "content-class": "edit-blob-dialog",
      "width": "500",
      "value": true
    },
    on: {
      "input": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_c('v-card', {
    style: {
      'background-color': _vm.skin.env_background_color
    }
  }, [_c('v-btn', {
    staticStyle: {
      "top": "12px",
      "right": "12px"
    },
    attrs: {
      "absolute": "",
      "small": "",
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        _vm.selected = null;
      }
    }
  }, [_vm._v(" Done ")]), _c('v-card-text', {
    staticClass: "pt-10 px-6 pb-6",
    class: {
      dark: _vm.isDarkEnv,
      error: {
        from: !_vm.from,
        to: !_vm.to
      }[_vm.selected.id]
    },
    staticStyle: {
      "background-color": "unset !important"
    }
  }, [_c('div', {
    staticClass: "d-flex mx-n3 mb-3"
  }, [_c('div', {
    staticClass: "edit-blob-label top"
  }, [_vm._v(_vm._s(_vm.LABELS[_vm.selected.id]))])]), _c('div', [_c('div', {
    directives: [{
      name: "el-resize",
      rawName: "v-el-resize",
      value: function (v) {
        _vm.selectedScale = v.width / _vm.selected.w;
      },
      expression: "v => { selectedScale = v.width / selected.w }"
    }],
    staticClass: "relative fill-width fill-height d-flex justify-center align-center",
    style: {
      'aspect-ratio': _vm.selected.w / _vm.selected.h
    }
  }, [_c('div', {
    staticClass: "absolute",
    staticStyle: {
      "inset": "-12px"
    }
  }, [_c('div', {
    staticClass: "edit-blob-outline",
    staticStyle: {
      "border-top-left-radius": "0",
      "outline-width": "2px"
    },
    style: {
      'border-bottom-left-radius': _vm.selected.id == 'to' && _vm.editToMultipleRecipients ? '0' : null
    }
  })]), _c('div', {
    staticClass: "absolute",
    style: {
      width: _vm.selected.w + 'px',
      height: _vm.selected.h + 'px',
      transform: `scale(${_vm.selectedScale})`
    }
  }, [_c('text-blob', {
    ref: "blob",
    attrs: {
      "mode": "edit",
      "blob": _vm.selected,
      "is-editable": {
        from: _vm.editFrom,
        to: _vm.editTo
      }[_vm.selected.id],
      "is-selected": true
    }
  })], 1)])]), _vm.selected.id == 'to' && _vm.editToMultipleRecipients ? _c('div', {
    staticClass: "d-flex mx-n3 mt-3"
  }, [_c('div', {
    staticClass: "edit-blob-label bottom"
  }, [_c('v-checkbox', {
    staticClass: "pt-0 mt-0",
    attrs: {
      "hide-details": "",
      "readonly": "",
      "label": _vm.editToMultipleRecipientsLabel,
      "dark": !_vm.isDarkEnv || !_vm.to,
      "disabled": _vm.editToMultipleRecipientsDisabled,
      "input-value": _vm.toMultipleRecipients
    },
    on: {
      "click": function () {
        _vm.$emit('update:multiple-recipients', !_vm.toMultipleRecipients);
        _vm.$nextTick(function () {
          return _vm.editTo && !_vm.to && _vm.$refs.blob.focus();
        });
      }
    }
  })], 1)]) : _vm._e()])], 1)], 1) : _vm._e(), _vm.containerHeight && _vm.$slots.below ? _c('div', {
    staticClass: "absolute",
    staticStyle: {
      "bottom": "0"
    },
    style: {
      width: `${_vm.width}px`,
      height: `${(_vm.containerHeight - _vm.width * 5 / 7) / 2}px`
    }
  }, [_vm._t("below")], 2) : _vm._e(), _vm.containerHeight ? _c('div', {
    staticClass: "env",
    class: _vm.state,
    style: {
      width: `${_vm.width}px`,
      height: `${_vm.width * 5 / 7}px`
    }
  }, [_c('div', {
    staticClass: "outside-back shadow d-flex justify-center align-center",
    class: _vm.outsideBackClass,
    style: Object.assign({}, _vm.style, {
      'background-color': _vm.skin.env_background_color
    })
  }, [_c('div', {
    staticClass: "absolute-fill back-card-gradient"
  }), _c('div', {
    staticClass: "absolute",
    staticStyle: {
      "width": "840px",
      "height": "600px",
      "pointer-events": "none"
    },
    style: {
      transform: `scale(${_vm.width / 840})`
    }
  }, _vm._l(_vm.blobs, function (_ref) {
    var blob = _ref[0],
      component = _ref[1],
      edit = _ref[2],
      editMultipleRecipients = _ref[3],
      hasError = _ref[4];
    return _c('div', {
      staticClass: "absolute",
      class: {
        'edit-blob-container': edit || editMultipleRecipients,
        dark: _vm.isDarkEnv
      },
      style: {
        top: 600 - blob.x - blob.h / 2 + 'px',
        left: blob.y - blob.w / 2 + 'px',
        width: blob.w + 'px',
        height: blob.h + 'px'
      },
      on: {
        "click": function () {
          if (edit || editMultipleRecipients) {
            _vm.$emit('click:' + blob.id);
            if (_vm.isSmall && blob.type == 'TEXT') {
              _vm.selected = blob;
              if (edit && !blob.text.text) _vm.$nextTick(function () {
                return _vm.$refs.blob.focus();
              });
            }
          }
        }
      }
    }, [component ? _c(component, {
      ref: blob.id,
      refInFor: true,
      tag: "component",
      attrs: {
        "mode": "edit",
        "tabindex": edit && blob.type == 'TEXT' ? null : '0',
        "blob": blob,
        "is-editable": edit && !_vm.isSmall,
        "is-selected": true
      },
      on: {
        "blur": function ($event) {
          return _vm.dirtyBlobIds.add(blob.id);
        }
      }
    }) : _vm._e(), edit || editMultipleRecipients ? _c('div', {
      staticClass: "absolute",
      style: {
        inset: blob.type == 'TEXT' ? '-12px' : '0'
      }
    }, [_c('div', {
      staticClass: "edit-blob-scale",
      class: {
        error: hasError && _vm.isDirty(blob.id)
      },
      style: {
        width: `${100 * _vm.width / 840}%`,
        height: `${100 * _vm.width / 840}%`,
        transform: `scale(${840 / _vm.width})`
      },
      on: {
        "click": function () {
          return edit && !_vm.isSmall && blob.type == 'TEXT' && _vm.$refs[blob.id][0].focus();
        }
      }
    }, [!_vm.isSmall ? _c('div', {
      staticClass: "edit-blob-label top"
    }, [_vm._v(_vm._s(_vm.LABELS[blob.id]))]) : _vm._e(), _c('div', {
      staticClass: "edit-blob-outline"
    }), !_vm.isSmall && editMultipleRecipients ? _c('div', {
      staticClass: "edit-blob-label bottom",
      on: {
        "click": function ($event) {
          $event.stopPropagation();
        }
      }
    }, [_c('v-checkbox', {
      staticClass: "pt-0 mt-0",
      attrs: {
        "hide-details": "",
        "readonly": "",
        "label": _vm.editToMultipleRecipientsLabel,
        "dark": !_vm.isDarkEnv || hasError && _vm.isDirty(blob.id),
        "disabled": _vm.editToMultipleRecipientsDisabled,
        "input-value": _vm.toMultipleRecipients
      },
      on: {
        "click": function (v) {
          _vm.$emit('update:multiple-recipients', !_vm.toMultipleRecipients);
          _vm.$nextTick(function () {
            return _vm.editTo && !_vm.to && _vm.$refs[blob.id][0].focus();
          });
        }
      }
    })], 1) : _vm._e()])]) : _vm._e()], 1);
  }), 0)]), _c('div', {
    staticClass: "inside-back shadow",
    style: _vm.style
  }, [_c('svg', {
    attrs: {
      "viewBox": "0 0 100 72",
      "preserveAspectRatio": "none"
    }
  }, [_c('defs', [_c('pattern', {
    attrs: {
      "id": "img-inside-back",
      "patternUnits": "userSpaceOnUse",
      "width": "100",
      "height": "100"
    }
  }, [_c('image', {
    attrs: {
      "href": "/textures/45-degree-fabric-light.png",
      "x": "0",
      "y": "0",
      "width": "100",
      "height": "100"
    }
  })])]), _c('rect', {
    attrs: {
      "width": "100",
      "height": "72",
      "fill": "#DDD"
    }
  }), _c('rect', {
    attrs: {
      "width": "100",
      "height": "72",
      "fill": _vm.skin.env_background_color,
      "fill-opacity": ".5"
    }
  }), _c('rect', {
    staticStyle: {
      "filter": "drop-shadow(0 0 1px rgba(0, 0, 0, .2))"
    },
    attrs: {
      "x": "4",
      "width": "92",
      "height": "68",
      "fill": "url(#img-inside-back)",
      "stroke": "#8882",
      "stroke-width": ".05"
    }
  })])]), _c('div', {
    staticClass: "inside-flap",
    style: _vm.style
  }, [_c('svg', {
    attrs: {
      "viewBox": "-5 0 110 72",
      "preserveAspectRatio": "none"
    }
  }, [_c('defs', [_c('linearGradient', {
    attrs: {
      "id": "gradient-inside-flap",
      "x1": "0",
      "x2": "0",
      "y1": "1",
      "y2": "0"
    }
  }, [_c('stop', {
    attrs: {
      "offset": "0%",
      "stop-color": "#BBB"
    }
  }), _c('stop', {
    attrs: {
      "offset": "15%",
      "stop-color": "#DDD"
    }
  })], 1), _c('pattern', {
    attrs: {
      "id": "img-inside-flap",
      "patternUnits": "userSpaceOnUse",
      "width": "100",
      "height": "100"
    }
  }, [_c('image', {
    attrs: {
      "href": "/textures/45-degree-fabric-light.png",
      "x": "0",
      "y": "0",
      "width": "100",
      "height": "100"
    }
  })])], 1), _c('path', {
    attrs: {
      "d": "M 0 72 Q 0 67 5 62 L 45 27 Q 50 22 55 27 L 95 62 Q 100 67 100 72",
      "fill": "url(#gradient-inside-flap)"
    }
  }), _c('path', {
    attrs: {
      "d": "M 0 72 Q 0 67 5 62 L 45 27 Q 50 22 55 27 L 95 62 Q 100 67 100 72",
      "fill": _vm.skin.env_background_color,
      "fill-opacity": ".5"
    }
  }), _c('path', {
    staticStyle: {
      "filter": "drop-shadow(0 0 1px rgba(0, 0, 0, .2))"
    },
    attrs: {
      "d": "M 4 72 Q 4 67 10 62 L 46.75 30.5 Q 50 27 53.25 30.5 L 90 62 Q 96 67 96 72 Z",
      "fill": "url(#img-inside-flap)",
      "stroke": "#8882",
      "stroke-width": ".05"
    }
  })])]), _c('div', {
    staticClass: "contents d-flex justify-center align-center",
    class: _vm.orientation,
    style: _vm.style
  }, [_c('div', {
    style: _vm.contentsStyle
  }, [_vm._t("default", null, null, _vm.contentsBounds)], 2)]), _c('canvas', {
    ref: "outside-panels",
    staticClass: "outside-panels",
    style: _vm.style,
    attrs: {
      "width": "1000",
      "height": "720"
    }
  }), _c('canvas', {
    ref: "outside-flap",
    staticClass: "outside-flap",
    style: _vm.style,
    attrs: {
      "width": "1100",
      "height": "720"
    }
  })]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }